class WcCartSubscription {
  constructor() {
    document.addEventListener('change', this.#onChange);
  }

  /** @param {Event} event */
  #onChange = async (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;

    const lineControl = target.closest('wc-cart-subscription-line');
    if (lineControl instanceof HTMLElement) {
      await this.#changeLine(lineControl, target);
      return;
    }

    const allControl = target.closest('wc-cart-subscription-all');
    if (allControl instanceof HTMLElement) {
      await this.#changeAll(allControl, target);
    }
  };

  /** @param {HTMLElement} control @param {HTMLInputElement | HTMLSelectElement} target */
  async #changeLine(control, target) {
    const toggle = control.querySelector('[data-wc-subscription-toggle]');
    const select = control.querySelector('[data-wc-subscription-plan]');
    const options = control.querySelector('[data-wc-subscription-options]');
    if (!(toggle instanceof HTMLInputElement) || !(select instanceof HTMLSelectElement)) return;

    if (target === toggle && options instanceof HTMLElement) options.hidden = !toggle.checked;
    const sellingPlan = toggle.checked ? Number(select.value) : null;
    if (toggle.checked && !Number.isInteger(sellingPlan)) return;

    await this.#apply(control, [
      {
        key: control.dataset.lineKey || '',
        sellingPlan,
      },
    ]);
  }

  /** @param {HTMLElement} control @param {HTMLInputElement | HTMLSelectElement} target */
  async #changeAll(control, target) {
    const toggle = control.querySelector('[data-wc-subscription-toggle-all]');
    const select = control.querySelector('[data-wc-subscription-plan-all]');
    const options = control.querySelector('[data-wc-subscription-options-all]');
    const data = control.querySelector('[data-wc-subscription-data]');
    if (
      !(toggle instanceof HTMLInputElement) ||
      !(select instanceof HTMLSelectElement) ||
      !(data instanceof HTMLScriptElement)
    ) {
      return;
    }

    if (target === toggle && options instanceof HTMLElement) options.hidden = !toggle.checked;

    let items;
    try {
      items = JSON.parse(data.textContent || '[]');
    } catch (error) {
      console.error(error);
      return;
    }
    if (!Array.isArray(items)) return;

    const planName = select.selectedOptions[0]?.dataset.planName || '';
    const changes = items
      .map((item) => ({
        key: item.key,
        sellingPlan: toggle.checked ? Number(item.plans?.[planName]) : null,
      }))
      .filter((item) => item.key && (item.sellingPlan === null || Number.isInteger(item.sellingPlan)));

    await this.#apply(control, changes);
  }

  /** @param {HTMLElement} control @param {Array<{key: string, sellingPlan: number | null}>} changes */
  async #apply(control, changes) {
    const status = control.querySelector('[data-wc-subscription-status]');
    const inputs = control.querySelectorAll('input, select');
    inputs.forEach((input) => {
      if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) input.disabled = true;
    });
    if (status instanceof HTMLElement) {
      status.hidden = false;
      status.textContent = Theme.translations.wcSubscriptionUpdating;
    }

    try {
      const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      let cart = await cartResponse.json();

      for (const change of changes) {
        const lineIndex = cart.items.findIndex((item) => item.key === change.key);
        if (lineIndex < 0) continue;

        const response = await fetch(Theme.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: lineIndex + 1,
            quantity: cart.items[lineIndex].quantity,
            selling_plan: change.sellingPlan,
          }),
        });
        cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'Cart update failed');
      }

      window.location.reload();
    } catch (error) {
      console.error(error);
      inputs.forEach((input) => {
        if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) input.disabled = false;
      });
      if (status instanceof HTMLElement) status.textContent = Theme.translations.wcSubscriptionError;
    }
  }
}

new WcCartSubscription();
